import { createJoonAPIClient } from "./joon-api"

type FamilyCheckoutResponse = {
  checkout_url: string | null
  has_trial: boolean
  trial_days: number | null
  client_secret: string | null
  stripe_publishable_key: string | null
  customer_session_client_secret: string | null
}

export const getFamilyStripeCheckoutLink = async ({
  familyId,
  campaign,
  embedded = false,
  applyTrial,
}: {
  familyId: number
  campaign: string | undefined
  embedded?: boolean
  applyTrial?: boolean
}): Promise<FamilyCheckoutResponse> => {
  const API = createJoonAPIClient()

  const params: Record<string, unknown> = { campaign, embedded }

  // Only sent when the caller wants to control the trial; the backend defaults
  // to applying an eligible trial when omitted.
  if (applyTrial !== undefined) params.apply_trial = applyTrial

  if (!embedded) {
    params.success_url = `${window.location.origin}/me?paid=true`
    params.cancel_url = window.location.href
  }

  const session = await API.get<FamilyCheckoutResponse>(
    `api/families/${familyId}/checkout/`,
    { params }
  )

  return session.data
}

export const getFamilyBillingLink = async ({
  familyId,
}: {
  familyId: number
}) => {
  const API = createJoonAPIClient()
  const session = await API.get(`api/families/${familyId}/billing/`, {
    params: { return_url: `${window.location.origin}/` },
  })
  return session.data.billing_url
}
